import React from 'react'
import classNames from 'classnames'

import { RegItemBuyingOptionsProps } from '../RegItemBuyingOptionsModal.types'
import css from '../RegItemBuyingOptionsModal.styles.scss'

const GiftCardBuyingOptions: React.FC<RegItemBuyingOptionsProps> = ({
  regItem,
}) => {
  const wrapperClasses = classNames(
    css.RegItemBuyingOptions,
    css.GiftCardBuyingOptions
  )

  return (
    <div className={wrapperClasses} data-testid="GiftCardBuyingOptions">
      GiftCardBuyingOptions: {regItem.id}
    </div>
  )
}

export default GiftCardBuyingOptions
